import styles from "./Skills.module.css"


const icons = ["JavaScript", "React", "Express", "Node.js", "Redux", "MongoDB", "Redis", "HTML", "CSS", "Bootstrap 5","Material UI", 
                "Typescript", "GIT", "Github", "Next.js"]

export const Skills = () => {

    return <div id="Skills" className={styles.Skills_container}>
        <div className={styles.Skills_inside_container}>
            <h2 className={styles.Tech_heading}>Tools & Skills</h2>

            <div class={styles.icons_container}>

                {icons.map((e) => {
                    return <div className={styles.icon}>
                        <img src={`./icons/${e}.svg`} alt="icons"/>
                        <p>{e}</p>
                    </div>
                })}
            </div>
        </div>
    </div>
}


